module.exports = __webpack_public_path__ + "static/media/Home_CSE.d1e8fcc5.jpg";